import { Fragment } from 'react';
import { ReviewProgress, ReviewFeedback, usePlai, PlaiViewType } from 'app/domains/review';
export function Review() {
    const { view } = usePlai();
    if (view !== PlaiViewType.Review) {
        return null;
    }
    return (<Fragment>
      <ReviewProgress />
      <ReviewFeedback />
    </Fragment>);
}
